/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'inbox': {
    width: 20,
    height: 21,
    viewBox: '0 0 20 21',
    data: '<defs/><path pid="0" id="inbox" class="cls-1" d="M39.707 177.707l-1.414-1.414L36 178.586V170h-2v8.586l-2.293-2.293-1.414 1.414L35 182.415zM38.586 183l-2 2h-3.172l-2-2H25v8h20v-8h-6.414zM43 189H27v-4h3.586l2 2h4.828l2-2H43v4z" transform="translate(-25 -170)"/>'
  }
})
